import { render, staticRenderFns } from "./CabeceraModalEditarBase.vue?vue&type=template&id=183aa10c&"
import script from "./CabeceraModalEditarBase.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalEditarBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('183aa10c', component.options)
    } else {
      api.reload('183aa10c', component.options)
    }
    module.hot.accept("./CabeceraModalEditarBase.vue?vue&type=template&id=183aa10c&", function () {
      api.rerender('183aa10c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Modal/CabeceraModalEditarBase.vue"
export default component.exports